import { render, staticRenderFns } from "./NewsViewItemDetail.vue?vue&type=template&id=41729af0&scoped=true"
import script from "./NewsViewItemDetail.vue?vue&type=script&lang=js"
export * from "./NewsViewItemDetail.vue?vue&type=script&lang=js"
import style0 from "./NewsViewItemDetail.vue?vue&type=style&index=0&id=41729af0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41729af0",
  null
  
)

export default component.exports